// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nw-1";
export var messageSideRight = "_nw-2";
export var subscribeToBackInStockBubbleContainer = "_nw-0";